import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { BottomSheet } from "../../components/ui/bottom-sheet";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminOffers() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", subtitle: "", image_url: "", discount_pct: "", active: true });

  const load = () => api.get("/offers/admin").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/offers", { ...form, discount_pct: form.discount_pct ? Number(form.discount_pct) : null });
      toast.success("Oferta creada");
      setForm({ title: "", subtitle: "", image_url: "", discount_pct: "", active: true });
      setOpen(false);
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const remove = async (id) => { await api.delete(`/offers/${id}`); load(); };

  return (
    <div className="min-h-screen bg-neutral-50">
      <main className="max-w-7xl mx-auto px-4 md:px-6 py-8">
        <div className="flex items-center justify-between">
          <h1 className="font-display text-4xl font-extrabold tracking-tight">Ofertas</h1>
          <Button onClick={() => setOpen(true)} className="h-11 bg-company text-[color:var(--company-primary-contrast)] hover:opacity-90 tap-fade" data-testid="add-offer-btn"><Plus size={16} className="mr-2" />Nueva</Button>
          <BottomSheet open={open} onOpenChange={setOpen} title="Nueva oferta" description="Esta oferta aparecerá en el carrusel del home." testid="offer-form-sheet">
            <div className="px-4 sm:px-6 pb-4 sm:pb-6">
              <div className="space-y-3">
                <div><Label>Título</Label><Input className="h-11" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="offer-title" /></div>
                <div><Label>Subtítulo</Label><Input className="h-11" value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} data-testid="offer-subtitle" /></div>
                <div><Label>URL imagen</Label><Input className="h-11" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} data-testid="offer-image" /></div>
                <div><Label>% descuento (opcional)</Label><Input type="number" className="h-11" value={form.discount_pct} onChange={(e) => setForm({ ...form, discount_pct: e.target.value })} data-testid="offer-discount" /></div>
                <Button onClick={save} className="w-full h-11 bg-company text-[color:var(--company-primary-contrast)] hover:opacity-90 tap-fade" data-testid="save-offer-btn">Guardar</Button>
              </div>
            </div>
          </BottomSheet>
        </div>
        <div className="mt-6 grid md:grid-cols-3 gap-3">
          {list.map((o) => (
            <div key={o.offer_id} className="bg-white rounded-xl border border-neutral-200 overflow-hidden" data-testid={`offer-${o.offer_id}`}>
              <div className="aspect-[16/9] bg-neutral-100"><img src={o.image_url} alt="" className="w-full h-full object-cover" /></div>
              <div className="p-4 flex justify-between items-start">
                <div>
                  <p className="font-semibold">{o.title}</p>
                  <p className="text-sm text-neutral-500">{o.subtitle}</p>
                  {o.discount_pct && <span className="text-xs font-bold bg-black text-white rounded-full px-2 py-0.5 mt-1 inline-block">-{o.discount_pct}%</span>}
                </div>
                <Button variant="ghost" size="icon" onClick={() => remove(o.offer_id)}><Trash2 size={16} /></Button>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
